import {
  BusinessInfoResponse,
  OwnershipType,
  ownershipValueToTitle,
} from '~domains/partner-application/entities/application';
import { getCategoryTitlesMap } from '~domains/partner-application/entities/application/lib';
import { useCategories } from '~domains/partner-application/entities/company-category';
import { financingPartnerTitleMap } from '~domains/partner-application/entities/financing-partners';
import { Card } from '~domains/partner-application/shared/ui/card';
import { DocumentReviewItem } from '~domains/partner-application/widgets/review-block/ui/document-review-item';

import { convertISOToPhDate } from '~shared/lib/convert-date';

import { ReviewItem } from './review-item';

type BusinessDetailsReviewProps = {
  businessInfo: BusinessInfoResponse | undefined;
  ownership: OwnershipType | undefined;
  onEdit?: () => void;
};

export const BusinessDetailsReview = ({
  businessInfo,
  ownership,
  onEdit,
}: BusinessDetailsReviewProps) => {
  const { data: categoriesData } = useCategories();
  const categoryTitlesMap = getCategoryTitlesMap(
    categoriesData?.categories || []
  );

  if (!businessInfo || !ownership) {
    return null;
  }

  return (
    <Card header="Business details" onEdit={onEdit}>
      <div className="grid grid-cols-2 gap-4">
        <ReviewItem
          title="Business type"
          value={ownershipValueToTitle[ownership]}
        />
        <ReviewItem
          title="Registered Business name"
          value={businessInfo.registeredBusinessName}
        />
        <ReviewItem
          title="BIR or DTI Registration Date"
          value={convertISOToPhDate(businessInfo.registrationDate)}
        />
        <ReviewItem
          title="Tax Identification number (TIN)"
          value={businessInfo.tinCode}
        />
        <ReviewItem
          title="Brand (Name shown on your store signage)"
          value={businessInfo.brandName}
        />
        <ReviewItem
          title="Other financing partners"
          value={businessInfo.otherFinancingPartners.map(
            (financingPartnerKey) =>
              financingPartnerTitleMap[financingPartnerKey]
          )}
        />
        <ReviewItem
          title="Product category"
          value={businessInfo.companyCategories.map(
            (category) => categoryTitlesMap[category.id]
          )}
        />
        <ReviewItem
          title="Other product category"
          value={businessInfo.companyCategoryOther}
          hideIfEmpty
        />
        {businessInfo.brandIcon && (
          <div className="col-span-full">
            <DocumentReviewItem
              title="Brand logo"
              document={businessInfo.brandIcon}
            />
          </div>
        )}
      </div>
    </Card>
  );
};
